<div class="image-container">
  <img [src]="imageUrl" [alt]="imgAlt" />
</div>
